import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import Table from "@/components/common/table";
import { Electricity_Source_List } from "../../../../tables-columns/Electricity-Source-List";
import Cookie from "js-cookie";
import axios from "axios";
import ActionButtons from "./ActionButtons/ActionButtons";
import ElectricitySourceModal from "./electricitySource/index";
import { authServices } from "services/auth.services";
import { ElectricitySourcesService } from "services/assets-electricitySource.services";
import DeleteModal from "../IrrigationNetwork/confirmDlete";
import EditElectricitySourceModal from "./electricitySource/editModal";
import ElectricityMetersModal from "./electricityMeters/index";
import { electricity_Meters_List } from "../../../../tables-columns/electricityMeters-List";
import { ElectricityMetersService } from "services/assets-electricityMeters.srvices";
import EditElectricityMetersModal from "./electricityMeters/editModal";
import Loader from "@/components/common/loader.components";
import PageTitle from "@/components/common/page-title.component";
import { setNotAuthorizedAlertData } from "@/redux/actions/notAuthorizedAlert";
import { useDispatch } from "react-redux";
type RowData = {
  id?: any;
};
export default function ElectricityNetwork({}) {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState<any>([]);
  const [rowData, setRowData] = useState<RowData>({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setpage] = useState(1);
  const dispatch = useDispatch();

  const [showElectricitySourceModal, setShowElectricitySourceModal] =
    useState(false);
  const [showElectricityMetersModal, setShowElectricityMetersModal] =
    useState(false);
  const [showEditElectricitySourceModal, setShowEditElectricitySourceModal] =
    useState(false);
  const [showEditElectricityMetersModal, setShowEditElectricityMetersModal] =
    useState(false);
  const router = useRouter();
  const SubCategorie = router.query;

  const getDlelteFunction = () => {
    if (SubCategorie.innerPage === "electricity-source") {
      return ElectricitySourcesService.deleteElectricitySources;
    } else if (SubCategorie.innerPage === "electricity-meters") {
      return ElectricityMetersService.deleteElectricityMeters;
    }
  };

  const tableActions = [
    {
      title: "view",
      action(row: any) {},
    },
    {
      title: "edit",
      action(row: any) {
        authServices.userValue.policy_data.asset.actions.includes?.("edit")
          ? (setRowData(row.original), gitEditModal())
          : dispatch(
              setNotAuthorizedAlertData({ key: "showModal", value: true })
            );
      },
    },

    {
      title: "delete",
      action(row: any) {
        authServices.userValue.policy_data.asset.actions.includes?.("delete")
          ? (setRowData(row.original), setShowDeleteModal(!showDeleteModal))
          : dispatch(
              setNotAuthorizedAlertData({ key: "showModal", value: true })
            );
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    const gitApiLink = () => {
      if (SubCategorie.innerPage === "electricity-source") {
        return `/electricity-sources/?org_id__id=${authServices.userValue.org_id}&page=${page}`;
      } else if (SubCategorie.innerPage === "electricity-meters") {
        return `/electricity-network-items/?org_id__id=${authServices.userValue.org_id}&page=${page}`;
      }
    };
    axios
      .get(gitApiLink(), {
        headers: {
          Authorization: `Bearer ${Cookie.get("token")}`,
        },
      })
      .then((response) => {
        const data = response.data;
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [SubCategorie]);

  useEffect(() => {
    const gitApiLink = () => {
      if (SubCategorie.innerPage === "electricity-source") {
        return `/electricity-sources/?org_id__id=${authServices.userValue.org_id}&page=${page}`;
      } else if (SubCategorie.innerPage === "electricity-meters") {
        return `/electricity-network-items/?org_id__id=${authServices.userValue.org_id}&page=${page}`;
      }
    };
    axios
      .get(gitApiLink(), {
        headers: {
          Authorization: `Bearer ${Cookie.get("token")}`,
        },
      })
      .then((response) => {
        const data = response.data;
        setTableData(data);
        setRefresh(0);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [refresh === 1]);

  const getShowButton = () => {
    if (SubCategorie.innerPage === "electricity-source") {
      return showElectricitySourceModal;
    } else if (SubCategorie.innerPage === "electricity-meters") {
      return showElectricityMetersModal;
    }
  };
  const getModal = () => {
    if (SubCategorie.innerPage === "electricity-source") {
      return setShowElectricitySourceModal;
    } else if (SubCategorie.innerPage === "electricity-meters") {
      return setShowElectricityMetersModal;
    }
  };
  const gitEditModal = () => {
    if (SubCategorie.innerPage === "electricity-source") {
      return setShowEditElectricitySourceModal(!showEditElectricitySourceModal);
    } else if (SubCategorie.innerPage === "electricity-meters") {
      return setShowEditElectricityMetersModal(!showElectricityMetersModal);
    }
  };

  const getColumns = () => {
    if (SubCategorie.innerPage === "electricity-source") {
      return Electricity_Source_List(t);
    } else if (SubCategorie.innerPage === "electricity-meters") {
      return electricity_Meters_List(t);
    }
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="flex items-center justify-between w-full">
        <PageTitle
          title={[t("Assets"), t(`${SubCategorie.innerPage}`)]}
          hasLink={true}
          link="/assets"
        />
        <ActionButtons
          showModal={getShowButton()}
          setShowModal={getModal()}
          label={t(`${SubCategorie.innerPage}`)}
        />
      </div>
      <Table
        fillPage={true}
        columns={getColumns()}
        data={tableData.results ?? []}
        tableAction={tableActions}
        manualPageination={true}
        totalPages={tableData.total_pages}
        goToPage={(currentPage) => setpage(currentPage)}
        crntpage={page}
      />
      <ElectricitySourceModal
        setRefresh={setRefresh}
        showModal={showElectricitySourceModal}
        setShowModal={setShowElectricitySourceModal}
      />
      <EditElectricitySourceModal
        setRefresh={setRefresh}
        showModal={showEditElectricitySourceModal}
        setShowModal={setShowEditElectricitySourceModal}
        rowData={rowData}
        setRowData={setRowData}
      />
      <ElectricityMetersModal
        setRefresh={setRefresh}
        showModal={showElectricityMetersModal}
        setShowModal={setShowElectricityMetersModal}
        rowData={rowData}
        setRowData={setRowData}
      />
      <EditElectricityMetersModal
        setRefresh={setRefresh}
        showModal={showEditElectricityMetersModal}
        setShowModal={setShowEditElectricityMetersModal}
        rowData={rowData}
        setRowData={setRowData}
      />
      <DeleteModal
        setRefresh={setRefresh}
        id={rowData?.id ?? null}
        setShowModel={setShowDeleteModal}
        showModel={showDeleteModal}
        deleteTrigger={getDlelteFunction()}
        /* mutate={mutate} */
      />
    </div>
  );
}
